// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCollateralEntriesV2 } from '@hooks/other/useCollateralEntriesV2';
import { useCollateralUserServiceV2 } from '@hooks/queries/collateralv2/onboarding/useUserService';
import { Outlet } from 'react-router-dom';
import Loading from '../../components/Loading';
import { CommonUtilitiesLayout } from '../../layout/CommonUtilitiesLayout';

export const CollateralV2: React.FC = () => {
  const userService = useCollateralUserServiceV2();

  const entries = useCollateralEntriesV2();
  const { isLoading } = userService;
  if (isLoading) return <Loading />;

  return (
    <CommonUtilitiesLayout entries={entries}>
      <Outlet />
    </CommonUtilitiesLayout>
  );
};
